﻿'use strict';


angular.module('ntmApp')
    .directive('hmsEditInputs', function () {

        return {
            restrict: 'E',
            templateUrl: 'ng1/src/directives/templates/HmsEditInputs.html',
            scope: {
                disabled: '=',
                duration: '=',
                onChange: '&',
                hideSeconds: '='
            },
            link: function (scope) {


                scope.changedTime = function () {
                    scope.duration = scope.time.hours * 60 + scope.time.minutes;
                    if (scope.time.seconds) {
                        scope.duration += scope.time.seconds / 60;
                    }
                };

                scope.updateDuration = function (value) {

                    var sighn = Math.sign(value);

                    var allMinuteTime = parseFloat(Math.abs(value));

                    var hours = Math.floor(allMinuteTime / 60);

                    var minutes = Math.floor(allMinuteTime - hours * 60);

                    var seconds = Math.round((allMinuteTime - ((hours * 60) + minutes)) * 60);

                    if (minutes === 60) { hours += 1; minutes = 0; }

                    if (seconds === 60) { minutes += 1; seconds = 0; }

                    scope.time = {
                        hours: sighn*hours,
                        minutes: minutes,
                        seconds: seconds
                    };
                };

                scope.$watch('duration', function (newValue) {
                    if (newValue) {
                        scope.updateDuration(newValue);
                        scope.onChange();
                    }
                });

                scope.updateDuration(scope.duration);
            }
        };
    });